import { cva } from 'class-variance-authority'

export const buttonVariants = cva('button', {
  variants: {
    intent: {
      'primary': 'button--primary',
      'outline': 'button--outline',
      'subtle': 'button--subtle',
      'clean': 'button--clean',
      'primary-inverted': 'button--primary-inverted',
      'outline-inverted': 'button--outline-inverted',
      'subtle-inverted': 'button--subtle-inverted',
      'clean-inverted': 'button--clean-inverted',
      'subtle-neutral': 'button--subtle-neutral',
      'subtle-quiet': 'button--subtle-quiet',
      'subtle-quiet-inverted': 'button--subtle-quiet-inverted',
      'subtle-menu': 'button--subtle-menu',
      'subtle-menu-item': 'button--subtle-menu-item',
    },
    size: {
      lg: 'button--lg',
      md: 'button--md',
      sm: 'button--sm',
      xs: 'button--xs',
    },
    shape: {
      button: '',
      circle: 'dds-button--circle',
    },
  },
  compoundVariants: [
    { shape: 'circle', size: 'md', class: 'button--circle-md' },
    { shape: 'circle', size: 'sm', class: 'button--circle-sm' },
    { shape: 'circle', size: 'xs', class: 'button--circle-xs' },
  ],
  defaultVariants: {
    intent: 'primary',
    size: 'md',
    shape: 'button',
  },
})
